import { Field, useFormikContext } from 'formik';
import SectionHeader from '../../../components/SectionHeader';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import CreateWarrantyFormModels from './CreateWarrantyFormModels';
import { useTranslation } from 'react-i18next';
import SwitchActivation from '../../../components/layout/SwitchActivation';
import useModelSelectOptions from '../../../hooks/useModelSelectOptions';
import { makesSelectProps } from '../../../utils/selectOptionsProps';
import useMultiSelectOptions from '../../../hooks/useMultiSelectOptions';
import { hasPermission } from '../../../utils/HelperFunctions';
import { Fragment } from 'react/jsx-runtime';

export default function CreateWarrantyFormInputs() {
  const { t } = useTranslation();
  const formik = useFormikContext<any>();

  const { modelOptions: vehicleMakesOptions } = useModelSelectOptions(makesSelectProps());

  const { element: makesMultiSelect } = useMultiSelectOptions({
    inputName: `vehicle_make_ids`,
    formik: formik,
    label: t('links.vehicle_makes'),
    placeholder: hasPermission(['makes.show']) ? t('links.vehicle_makes') : t('no_permission_to_show'),
    selectOptions: vehicleMakesOptions,
    disabled: !hasPermission(['makes.show'])
  });

  return (
    <Fragment>
      <SectionHeader title={t('warranty_details')} customStyle="last">
        <div className="inputs_group">
          <FieldWrapper title={t('code')} inputName={`code`} inputPlaceholder={t('code')} input customPadding />
          <FieldWrapper />
        </div>
        <div className="inputs_group">
          <FieldWrapper title={t('title_en')} inputName={`title[en]`} inputPlaceholder={t('title_en')} input customPadding />
          <FieldWrapper title={t('title_ar')} inputName={`title[ar]`} inputPlaceholder={t('title_ar')} input customPadding />
        </div>
        <div className="inputs_group">
          <FieldWrapper title={t('description_en')} inputName={`description[en]`} inputPlaceholder={t('description_en')} textArea customPadding maxLength={2200} />
          <FieldWrapper title={t('description_ar')} inputName={`description[ar]`} inputPlaceholder={t('description_ar')} textArea customPadding maxLength={2200} />
        </div>
        <div className="inputs_group">
          <div className="switch_container">
            <SwitchActivation onChange={(value: any) => formik.setFieldValue('is_default', value?.target?.checked ? 1 : 0)} active={formik.values.is_default} />
            <p>{t('is_default')}</p>
          </div>
        </div>
      </SectionHeader>
      {!formik?.values?.is_default && (
        <SectionHeader title={t('models')} customStyle="last">
          <div className="inputs_group">
            {makesMultiSelect}
            <FieldWrapper />
          </div>
          {formik?.values?.vehicle_make_ids?.map((make: number) => (
            <CreateWarrantyFormModels key={make} formik={formik} makeObj={vehicleMakesOptions?.find((item: any) => item.value == make)} />
          ))} 
        </SectionHeader>
      )}
    </Fragment>
  );
}
